export default __webpack_public_path__ + "static/media/82_photo.946b0e0c.jpg";